import React, { useState, useEffect } from 'react';

function Album({ album }) {
  const [selectedSong, setSelectedSong] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check window width to determine mobile status.
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Set initial value.
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Disable background scrolling when modal is open on mobile.
  useEffect(() => {
    if (selectedSong && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedSong, isMobile]);

  const albumLink = album.link && album.link !== "" ? album.link : null;

  return (
    <div className="album-container">
      <div className="album-content">
        <div className="album-info">
          {/* Wrap cover and title in an anchor if a link exists */}
          { albumLink ? (
            <a
              href={albumLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <img 
                src={album.cover} 
                alt={album.title} 
                className="album-cover"
              />
              <h3>{album.title}</h3>
            </a>
          ) : (
            <>
              <img 
                src={album.cover} 
                alt={album.title} 
                className="album-cover"
              />
              <h3>{album.title}</h3>
            </>
          )}

          {/* Optionally display the logo or text */}
          <div 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'start',
              marginTop: '0.5rem'
            }}
          >
            { albumLink && (
              albumLink.includes("open.spotify.com") ? (
                <a href={albumLink} target="_blank" rel="noopener noreferrer">
                  <img 
                    src="spotify_logo.png" 
                    alt="Spotify" 
                    style={{ width: "24px", height: "24px" }} 
                  />
                </a>
              ) : (
                <a href={albumLink} target="_blank" rel="noopener noreferrer">
                  (Listen online)
                </a>
              )
            )}
          </div>

          <div className="tracklist">
            <ul>
              {album.songs?.map((song, index) => (
                <li 
                  key={index}
                  className={`song ${selectedSong === song ? "active" : ""}`}
                  onClick={() => setSelectedSong(song)}
                >
                  {song.title}
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        {selectedSong && (
          isMobile ? (
            // On mobile, render the lyrics as a modal with a fixed header.
            <div className="lyrics-modal">
              <div className="lyrics-panel modal">
                <div className="modal-header">
                  <h3>{selectedSong.title}</h3>
                  <button 
                    className="close-button" 
                    onClick={() => setSelectedSong(null)}
                  >
                    ×
                  </button>
                </div>
                <div className="modal-content">
                  <pre>{selectedSong.lyrics}</pre>
                </div>
              </div>
            </div>
          ) : (
            // On larger screens, show the lyrics inline.
            <div className="lyrics-panel">
              <h3>{selectedSong.title}</h3>
              <br />
              <pre>{selectedSong.lyrics}</pre>
              <button 
                onClick={() => setSelectedSong(null)}
                className="close-button"
              >
                Close
              </button>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default Album;


// import React, { useState } from 'react';

// function Album({ album }) {
//   const [selectedSong, setSelectedSong] = useState(null);

//   return (
//     <div className="album-container">
//       <div className="album-content">
//         <div className="album-info">
//           <img 
//             src={album.cover} 
//             alt={album.title} 
//             className="album-cover"
//           />
//           <div 
//             style={{ 
//               display: 'flex', 
//               alignItems: 'center', 
//               justifyContent: 'start',
//               marginTop: '0.5rem'
//             }}
//           >
//             <h3>{album.title}</h3>
//             { album.link && album.link !== "" && (
//               album.link.includes("open.spotify.com") ? (
//                 <a href={album.link} target="_blank" rel="noopener noreferrer">
//                   <img 
//                     src="spotify_logo.png" 
//                     alt="Spotify" 
//                     style={{ width: "24px", height: "24px" }} 
//                   />
//                 </a>
//               ) : (
//                 <a href={album.link} target="_blank" rel="noopener noreferrer">
//                   (Listen online)
//                 </a>
//               )
//             )}
//           </div>
//           <div className="tracklist">
//             <ul>
//               {album.songs?.map((song, index) => (
//                 <li 
//                   key={index}
//                   className={`song ${selectedSong === song ? "active" : ""}`}
//                   onClick={() => setSelectedSong(song)}
//                 >
//                   {song.title}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
        
//         {selectedSong && (
//           <div className="lyrics-panel">
//             <h3>{selectedSong.title}</h3>
//             <br />
//             <pre>{selectedSong.lyrics}</pre>
//             <button 
//               onClick={() => setSelectedSong(null)}
//               className="close-button"
//             >
//               Close
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Album;

